<template>
  <div class="rt-search">
    <el-input
      v-if="showSearch"
      :value="value"
      v-bind="$attrs"
      :placeholder="placeholder"
      @keyup.enter.native="enterHander"
      @input="inputHander"
    >
      <rt-icon slot="suffix" name="rt-base-lookup" @click="onSearch" />
    </el-input>

    <div v-if="more" class="rt-search-more" @click="onMore">
      <rt-button :suffix-icon="suffixIcon" type="plain" text>
        {{ $tx('更多筛选', 'xpc.search.more') }}
      </rt-button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { store } from '../table/store';
import RtIcon from '../icon/rtIcon';
import RtButton from '../button/rtButton';
export default {
  name: 'RtSearch',
  components: {
    RtIcon,
    RtButton
  },
  props: {
    value: [String, Number],
    placeholder: {
      type: String,
      default() {
        return this.$tx('搜索', 'xpc.search.search');
      }
    },
    more: {
      type: Boolean,
      default: true
    },
    showSearch: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      state: store.state
    };
  },
  computed: {
    suffixIcon() {
      return this.state.showMore ? 'rt-base-arrowup2' : 'rt-base-arrowdown2';
    },
    iconDirector() {
      return {
        'has-more': !!this.state.showMore
      };
    }
  },
  activated() {
    store.TOGGLE_SHOW_MORE(false);
  },
  methods: {
    enterHander() {
      this.onSearch();
    },
    inputHander(value) {
      this.$emit('input', value);
    },
    onSearch() {
      this.$emit('on-search', this.value);
    },
    onMore() {
      store.TOGGLE_SHOW_MORE(!this.state.showMore);
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtSearch.vue?56013b48